<template>
  <ItemListPagination
    :class="$style.invoiceItemListPagination"
    :columns="$options.columns"
    :currentPageNum="currentPageNum"
    :itemComponent="itemComponent"
    :rowsPerPage="rowsPerPage"
    :showEmptyState="showEmptyState"
    :tableData="visibleTableData"
    :totalCount="totalCount"
    @pageChange="handlePageChange"
  >
    <template v-slot:emptyState>
      <NoSearchResults
        ctaText=""
        instructions=""
        :src="noResultsIllustration"
        title="No invoices found"
      />
    </template>
  </ItemListPagination>
</template>

<script>
import {
  ItemListPagination,
  NoSearchResults,
  Types,
} from '@jumpcloud/ui-components';
import { columnsData } from 'client/Account/InvoicesPage/InvoiceAttributesConsts';
import Constants from 'client/util/Constants';
import InvoicesItemRow from 'client/Account/InvoicesPage/InvoicesItemRow.vue';

const { Column } = Types;
const { noResultsIllustration } = Constants;

const columns = columnsData.map(columnConfig => Column(columnConfig));

export default {
  name: 'InvoicesTable',

  components: {
    ItemListPagination,
    NoSearchResults,
  },

  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      totalCount: this.tableData.length,
      rowsPerPage: 10,
      currentPageNum: 0,
      selectable: false,
      visibleTableData: this.tableData.slice(0, 10),
      showEmptyState: !this.tableData.length,
    };
  },

  created() {
    this.itemComponent = InvoicesItemRow;
    this.noResultsIllustration = noResultsIllustration;
  },

  methods: {
    handlePageChange({ currentPageNum, rowsPerPage }) {
      this.currentPageNum = currentPageNum;
      this.rowsPerPage = rowsPerPage;

      const start = currentPageNum * rowsPerPage;
      const end = start + rowsPerPage;
      this.visibleTableData = this.tableData.slice(start, end);
    },

  },

  columns,
};
</script>

<style module>
/* as there is no toolbar defined, original `grid-template-rows: auto 1fr auto` does not work here
`NoSearchResults` is not visible in that case */
.invoiceItemListPagination {
  grid-template-rows: auto !important;
}

.invoiceItemListPagination label {
  color: var(--jcGrey);
  font-weight: 600;
}
</style>
